export default __webpack_public_path__ + "static/media/hand-focus-icon.5bb0e3b5.svg";